module.exports = __webpack_public_path__ + "static/media/defaultAvatar23.1db9297a.svg";